






























import { Component, Prop, Vue } from 'vue-property-decorator';
import Photo from '@/components/Photo.vue';
import { Product } from '@/store/types/work/invoice';
import { Categories, Category } from '@/types/work/product_category';
import { Getter } from 'vuex-class';
import { GET_CATEGORIES } from '@/store/models/work/enterprise/products/categories';
import ChangeProduct from '@/components/work/invoices/product/ChangeProduct.vue';
import ChangeProductValue from '@/components/work/invoices/product/ChangeProductValue.vue';
@Component({
  components: { ChangeProductValue, ChangeProduct, Photo }
})
export default class ProductItem extends Vue {
  @Prop() product!: Product;
  @Prop() outgoing!: boolean;
  @Getter(GET_CATEGORIES) categories!: Category[];
  public showEdit = false;
  public showEditRealValue = false;

  get categoryHierarchy ():Array<any> {
    return (new Categories(this.categories).getHierarchy(this.product.from_product_category_id));
  }

  productUpdated () {
    this.showEdit = false;
    this.showEditRealValue = false;
    this.$emit('updated');
  }
}
